module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-101-retro.ec381b91.jpg";